import accountVerifyIcon from "../../../../assets/design-icons/account_verify.svg";
import depositIcon from "../../../../assets/design-icons/deposit.svg";
import withdrawalIcon from "../../../../assets/design-icons/withdrawal.svg";
import otpLoginIcon from "../../../../assets/design-icons/otp_login.svg";
import rewardsEventsIcon from "../../../../assets/design-icons/rewards_events.svg";
import eventIssueIcon from "../../../../assets/design-icons/event_issue.svg";
import accountIssueIcon from "../../../../assets/design-icons/account_issue.svg";
import promoBonusIcon from "../../../../assets/design-icons/promo_bonus.svg";

export const DESIGN_ICON_SRC_MAP: Record<string, string> = {
  account_verify: accountVerifyIcon,
  deposit: depositIcon,
  withdrawal: withdrawalIcon,
  otp_login: otpLoginIcon,
  rewards_events: rewardsEventsIcon,
  event_issue: eventIssueIcon,
  account_issue: accountIssueIcon,
  promo_bonus: promoBonusIcon,
};

export const DESIGN_ICON_PRESETS = Object.keys(DESIGN_ICON_SRC_MAP);
